class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = this.querySelector("[data-add-to-cart-button]");
    this.variantSelect = this.querySelector("[data-variant-select]");
    this.productForm = document.querySelector("product-form");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector("[data-add-to-cart-button]");
    this.loadingSpinner = this.submitButton.querySelector(".loading__spinner");
    this.submitButtonText = this.submitButton.querySelector("span");
  }

  connectedCallback() {
    this.initWhenNotVisible({
      callback: (isVisible) => {
        if (isVisible) {
          this.show();
        } else {
          this.hide();
        }
      },
      element: this.productForm,
    });

    this.addToCartButton.addEventListener(
      "click",
      this.handleAddToCart.bind(this)
    );

    if (this.variantSelect) {
      this.variantSelect.addEventListener(
        "change",
        this.handleVariantChange.bind(this)
      );
    }
  }
  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  initWhenNotVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;
    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback(true);
            }
          } else {
            if (typeof options.callback === "function") {
              options.callback(false);
            }
          }
        });
      },
      { rootMargin: `-${threshold}px 0px 0px 0px` }
    );
    observer.observe(options.element);
  };

  show() {
    this.classList.add("is-visible");
  }

  hide() {
    this.classList.remove("is-visible");
  }

  getVariants() {
    return (
      this.variants ||
      JSON.parse(this.productForm.querySelector("script").textContent)
    );
  }

  handleVariantChange() {
    const variants = this.getVariants();
    const variantId = this.variantSelect.value;
    const variant = variants.find((variant) => variant.id === variantId);
    if (variant) {
      if (variant.available) {
        this.toggleSubmitButton(false, window.variantStrings.addToCart);
      } else {
        this.toggleSubmitButton(true, window.variantStrings.soldOut);
      }
    } else {
      this.toggleSubmitButton(true, window.variantStrings.unavailable);
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute("disabled", "disabled");
      if (text) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute("disabled");
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  handleAddToCart(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading__spinner").classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", this.variantSelect.value);
    formData.append("quantity", 1);

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message,
          });

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButtonText.classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.error = false;
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner").classList.add("hidden");
      });
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);
